<template>
    <v-dialog v-model="modal" :scrim="false" :persistent="loading">
        <v-card>
            <v-card-title class="text-white bg-primary">
                {{ serviceDetails.hotelName }}
            </v-card-title>
            <v-card-text v-if="bookingFieldsLoading" class="d-flex full-width align-center justify-center pa-8">
                <v-progress-circular color="primary" indeterminate size="64" />
            </v-card-text>
            <template v-else>
                <v-card-text>
                    <div class="my-5">
                        <template v-for="(tourist, index) in tourists" :key="'_' + index">
                            <hotel-tourist-form
                                :ref="addFormRef"
                                v-model="tourists[index]"
                                :room-index="0"
                                :index="index"
                                :standard-meal-name="getMealName(index)"
                                :start-date="startDate"
                                :hide-index="tourists.length === 1"
                                :hotel="service"
                                :data-cy="`tourist-${index}`"
                                @change-passport="onTouristsChange"
                            />
                        </template>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" :disabled="loading" :loading="loading" @click="save">
                        {{ $t('save') }}
                    </v-btn>
                    <v-btn variant="text" :disabled="loading" @click="modal = false">{{ $t('cancel') }}</v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel, Watch} from 'vue-facing-decorator'
    import {BookingTouristsMixin} from '~src/components/booking/mixins/BookingTouristsMixin.vue'
    import HotelTouristForm from '@/components/booking/forms/HotelTouristForm.vue'
    // TODO: I think need to remove HotelPageMixin from FillAccommodationBookingDataModal
    import {HotelPageMixin} from '@/components/hotels/mixins/HotelPageMixin.vue'
    import {FillServiceBookingDataMixin} from '@/components/account/mixins/FillServiceBookingDataMixin.vue'

    //TODO Add train stations
    @Component({
        components: {
            HotelTouristForm,
        },
    })
    export class FillAccommodationBookingDataModal extends mixins(
        BookingTouristsMixin,
        HotelPageMixin,
        FillServiceBookingDataMixin
    ) {
        @VModel() modal
        @Prop({required: true}) service
        @Prop({required: true}) order

        loading = false

        @Watch('modal')
        async onModalOpen() {
            if (this.modal) {
                this.setTourists()
                hotelsStore.SET_TOURISTS([persistentStore.tourists])
                await this.loadTouristBookingFields()
                await this.$nextTick()
                this.allNestedFormsValid = await this.validateNestedForms(this)
            }
        }

        async mounted() {
            await this.$store.restored
            await this.loadRuntimeData()
        }

        async save() {
            this.allNestedFormsValid = await this.validateNestedForms(this)
            if (!this.allNestedFormsValid) return
            try {
                this.loading = true
                const touristsWithPassport = this.tourists.map((t, i) => {
                    return {...t, passport: hotelsStore.tourists[0][i].passport}
                })
                await this.$api.fillAccommodationBookingData.post({
                    tourists: this.prepareBookTourists(touristsWithPassport),
                    processId: this.service.processId,
                })
                await runtimeStore.refreshOrder()
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.modal = false
                this.loading = false
            }
        }

        getMealName(index) {
            const travelerId = this.service.travelers[index]?.travelerId
            const room = this.serviceDetails.rooms.find(room => {
                return room.travelerIds.travelerId.includes(travelerId)
            })

            return room?.mealTypeName
        }

        get ownProduct() {
            return hotelsRuntimeStore.ownProduct(this.service)
        }

        get serviceDetails() {
            return this.service.serviceDetails[0]
        }

        // TODO Need refactoring in all modals
        get searchRequest() {
            return {
                dateTime: this.service.startDateTime.split(' ')[0],
                adults: this.service.travelers.filter(({isChild}) => !isChild).length,
                childrenAges: this.service.travelers.reduce((childrenAges, {isChild, dateOfBirth, age}) => {
                    if (age !== undefined) {
                        childrenAges.push(age)
                    } else if (isChild) {
                        if (dateOfBirth) {
                            childrenAges.push(
                                this.$dateFns.differenceInYears(
                                    new Date(this.service.startDateTime),
                                    this.$dateFns.parseISO(dateOfBirth)
                                )
                            )
                        } else {
                            childrenAges.push(4)
                        }
                    }
                    return childrenAges
                }, []),
            }
        }

        get startDate() {
            return this.searchRequest.dateTime
        }
    }

    export default FillAccommodationBookingDataModal
</script>
